import React from 'react';
import SpeedItemPhoneLine from './SpeedItemPhoneLine';
import { NO_LOCK_IN_CONTRACT } from "../constants";
import Badge from "./Badge";

const SpeedItem = (props) => {
    
    return (
        <div className={'speed-item ' + props.active} onClick={event => props.handleChangeSpeed(props.id, props.position, event)}>
            <div className="bg-indigo">
                {props.isRecommendedPlan ? <Badge /> : <div style={{minHeight: '20px'}} />}
                <h3 className="color-lime mt-2">{props.planDescription.title}</h3>
                <h5 className="mb-0 color-white">
                    {props.plan.planFullSpeed} Mbps
                </h5>
                <h6 className="m-0 color-white">Typical business hour speed {props.plan.typicalEveningSpeed}</h6>  
            </div>
            <p className="price mt-3">${props.calcMonthlyPrice(props.plan)}/mth</p>
            <p className="font-small m-0">
                {/* {props.plan.special && props.plan.special.planPrice ? `for first ${props.plan.special.duration} then $${props.calcPrice(props.plan.price)}/mth ongoing` : <span dangerouslySetInnerHTML={{__html: '&nbsp;'}}></span>}                                 */}
                Promo price for the first 6 months.
            </p>          
            <p className="bold font-large mt-3 mb-0">{props.plan.allowance}</p>
            <p className="font-medium m-0">{NO_LOCK_IN_CONTRACT}</p>
            <div className="separator" />
            {props.plan.speedboost ?
                <div className='sb-free-container bg-lightgrey ml-3'>
                    <img src='/images/mini-boost.svg' alt='mini-boost' />
                    <p className='font-tiny m-0 semi-bold text-center'>
                        <a className='color-indigo underline' href='/speed-boost' target='_blank' rel='noreferrer'>My Speed Boost™</a> Eligible
                    </p>
                    <p className='font-tiny m-0 semi-bold text-center'>
                        5 Speed Upgrade Days per month included
                    </p>
                </div>
            : ''}
            <ul className="pricing">
                <li>5-minute support guarantee</li>
                <li>Extended business hours support</li>
                {/* {props.plan.special && props.plan.special.planPrice ? <li className="font-tiny">for first {props.plan.special.duration} then {props.plan.price} thereafter</li> : ''} */}
                <li>Dedicated connection manager</li>
                <li>Static IP address</li>
            </ul>
            {
                props.isPhoneIncluded && <SpeedItemPhoneLine />
            }
        </div>
    );

};

export default SpeedItem;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/SpeedItem.js